import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { toast } from 'react-toastify';
import { login } from '../actions/auth';
import apiService from '../services.js/apiService';

const LoginForm = (props) => {
  const [formData, setFormData] = useState({
    email:    '',
    password: '',
  });

  const { email, password } = formData;

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      const { token, user } = await apiService.login({ email, password });
      props.dispatchLogin({ token, user });
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <div id="admin-login" className="mx-auto mt-5">
      <div className="card">
        <div className="card-header">
          <h1 className="text-center h2 p-1">Sign in</h1>
        </div>
        <div className="card-body">
          <p className="card-title text-center mb-4">
            <i className="fa fa-user" />
            {' '}
            Sign into Your Account
          </p>
          <form className="form" onSubmit={(e) => onSubmit(e)}>
            <div className="form-group">
              <input
                className="form-control"
                type="text"
                placeholder="Email"
                name="email"
                value={email}
                onChange={(e) => onChange(e)}
                required
              />
            </div>
            <div className="form-group">
              <input
                className="form-control"
                type="password"
                placeholder="Password"
                name="password"
                value={password}
                onChange={(e) => onChange(e)}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="submit"
                className="btn btn-success form-control mt-3"
                value="Login"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

LoginForm.propTypes = {
  dispatchLogin: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  dispatchLogin: ({ token, user }) => dispatch(login({ token, user })),
});

export default connect (null, mapDispatchToProps)(LoginForm);
